import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import DraftMain     from './draft';
import ContentsTab   from 'contents_tab';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DraftSecret extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      draftData: {},
      is_send : false,
    };
  }
  // -------------------------------------------------------
  
  change() {
    this.setState({ is_send: (this.password.value != '') });
  }
  // -------------------------------------------------------
  
  sendPassword(draft_id, mode) {
    Utils.request.bind(this)('/api/draft/send_secret_login', { unique_code: this.props.data.unique_code, password: this.password.value },
      function(res){
        this.setState({ draftData: res.body.data });
      }.bind(this),
      function(res){
        alert(res.body.msg);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let draftData = this.state.draftData;
    
    if( Object.keys(draftData).length == 0){
      if(data.flow_no > data.order_no ) return <div id="draft"><div className="draft-secret none">下書きの確認が完了しました。</div></div>;
      if(data.flow_no < data.order_no ) return <div id="draft"><div className="draft-secret none">下書き依頼の準備中です。しばらくお待ち下さい。</div></div>;
      
      return (
        <div id="draft">
          <div className="draft-secret form">
            <h1>下書き確認</h1>
            <h2>{data.project_name}</h2>
            <h3>@{data.insta_id}</h3>
            
            <input className="text" type="text" ref={(input) => { this.password = input }} onChange={this.change.bind(this)} placeholder={'下書きを編集するためのパスワードを入力してください'} />
            
            { (this.state.is_send == true)
              ? <div className="button on" onClick={this.sendPassword.bind(this)}>送信</div>
              : <div className="button off">送信</div>
            }
          </div>
        </div>
      );
      
    } else {
      return (
        <div>
          <DraftMain data={Object.assign(data, this.state.draftData)} is_secret_mode={true} after_detail={{ authority: 0, is_flow_action: true, is_secret_mode: true, is_send_action: data.is_send_action }} />
        </div>
      );
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftSecret;